import React from 'react';
import './PetAnimations.css';

export default function MocchiRabbitSvg({ size = 120, color, className = '' }) {
  const bodyColor = color || '#F8C8D2';
  const bodyLight = '#FFE4EA';
  const innerPink = '#F297A6';
  const cream = '#FFF7E8';

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      fill="none"
      className={`pet-svg pet-idle ${className}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Soft shadow */}
      <ellipse cx="60" cy="104" rx="34" ry="4" fill={innerPink} opacity="0.2" />
      {/* Mochi body (very round) */}
      <ellipse cx="60" cy="72" rx="36" ry="30" fill={bodyColor} />
      {/* Body highlight */}
      <ellipse cx="48" cy="60" rx="14" ry="10" fill={bodyLight} opacity="0.7" />
      {/* Belly patch */}
      <ellipse cx="60" cy="86" rx="18" ry="10" fill={cream} opacity="0.7" />
      {/* Tiny feet poking out */}
      <ellipse cx="46" cy="100" rx="6" ry="3" fill={cream} />
      <ellipse cx="74" cy="100" rx="6" ry="3" fill={cream} />
      {/* Tiny paws */}
      <ellipse cx="38" cy="84" rx="5" ry="4" fill={bodyColor} />
      <ellipse cx="82" cy="84" rx="5" ry="4" fill={bodyColor} />
      {/* Long floppy ears */}
      <ellipse cx="44" cy="32" rx="8" ry="20" fill={bodyColor} transform="rotate(-12 44 32)" />
      <ellipse cx="76" cy="32" rx="8" ry="20" fill={bodyColor} transform="rotate(12 76 32)" />
      {/* Inner ears */}
      <ellipse cx="44" cy="34" rx="4" ry="14" fill={innerPink} transform="rotate(-12 44 34)" opacity="0.7" />
      <ellipse cx="76" cy="34" rx="4" ry="14" fill={innerPink} transform="rotate(12 76 34)" opacity="0.7" />
      {/* Face (no separate head, it's all mochi) */}
      {/* Eyes (closed dot-style) */}
      <ellipse cx="50" cy="62" rx="2.5" ry="3" fill="#2C2419" />
      <ellipse cx="70" cy="62" rx="2.5" ry="3" fill="#2C2419" />
      <circle cx="50.5" cy="61" r="0.8" fill="white" />
      <circle cx="70.5" cy="61" r="0.8" fill="white" />
      {/* Tiny pink nose */}
      <path d="M58 70L60 72L62 70Z" fill={innerPink} />
      {/* Smile */}
      <path d="M60 72C58 75 56 75 55 74" stroke={innerPink} strokeWidth="1" strokeLinecap="round" fill="none" />
      <path d="M60 72C62 75 64 75 65 74" stroke={innerPink} strokeWidth="1" strokeLinecap="round" fill="none" />
      {/* Rosy cheeks */}
      <circle cx="44" cy="70" r="4" fill={innerPink} opacity="0.4" />
      <circle cx="76" cy="70" r="4" fill={innerPink} opacity="0.4" />
      {/* Sparkle */}
      <path d="M28 50L29 48L30 50L29 52Z" fill="white" opacity="0.6" />
      <path d="M90 54L91 52L92 54L91 56Z" fill="white" opacity="0.6" />
    </svg>
  );
}
